<template>
  <div>
    <v-flex v-if="selected">
      <v-card class="mb-2" :class="{ active: event._id === selected._id }" flat hover ripple color="accent" @click.prevent="onClick(index)">
        <div :class="tabClasses">
          <v-list-tile avatar>
            <v-list-tile-avatar class="avatarDisplay" v-if="event._source.eventImportance === 'Critical'">
              <img src="./side-drawer-assets/PoliceCritical.svg" v-if="event._source.eventCategory === 'Plc'" />
              <img src="./side-drawer-assets/HealthCritical.svg" v-if="event._source.eventCategory === 'Hlt'" />
              <img src="./side-drawer-assets/NaturalDisasterCritical.svg" v-if="event._source.eventCategory === 'ND'" />
              <img src="./side-drawer-assets/MoneyCritical.svg" v-if="event._source.eventCategory === 'Mny'" />
              <img src="./side-drawer-assets/PoliticsCritical.svg" v-if="event._source.eventCategory === 'Plt'" />
              <img src="./side-drawer-assets/SportsCritical.svg" v-if="event._source.eventCategory === 'Spt'" />
              <img src="./side-drawer-assets/TrafficCritical.svg" v-if="event._source.eventCategory === 'Traffic'" />
            </v-list-tile-avatar>
            <v-list-tile-avatar v-if="event._source.eventImportance === 'Information'">
              <img src="./side-drawer-assets/PoliceInformation.svg" v-if="event._source.eventCategory === 'Plc'" />
              <img src="./side-drawer-assets/HealthInformation.svg" v-if="event._source.eventCategory === 'Hlt'" />
              <img src="./side-drawer-assets/NaturalDisasterInformation.svg" v-if="event._source.eventCategory === 'ND'" />
              <img src="./side-drawer-assets/MoneyInformation.svg" v-if="event._source.eventCategory === 'Mny'" />
              <img src="./side-drawer-assets/PoliticsInformation.svg" v-if="event._source.eventCategory === 'Plt'" />
              <img src="./side-drawer-assets/SportsInformation.svg" v-if="event._source.eventCategory === 'Spt'" />
              <img src="./side-drawer-assets/TrafficInformation.svg" v-if="event._source.eventCategory === 'Traffic'" />
            </v-list-tile-avatar>
            <v-list-tile-avatar v-if="event._source.eventImportance === 'Warning'">
              <img src="./side-drawer-assets/PoliceWarning.svg" v-if="event._source.eventCategory === 'Plc'" />
              <img src="./side-drawer-assets/HealthWarning.svg" v-if="event._source.eventCategory === 'Hlt'" />
              <img src="./side-drawer-assets/NaturalDisasterWarning.svg" v-if="event._source.eventCategory === 'ND'" />
              <img src="./side-drawer-assets/MoneyWarning.svg" v-if="event._source.eventCategory === 'Mny'" />
              <img src="./side-drawer-assets/PoliticsWarning.svg" v-if="event._source.eventCategory === 'Plt'" />
              <img src="./side-drawer-assets/SportsWarning.svg" v-if="event._source.eventCategory === 'Spt'" />
              <img src="./side-drawer-assets/TrafficWarning.svg" v-if="event._source.eventCategory === 'Traffic'" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-sub-title class="eventTitle">{{ event._source.eventTitle }}</v-list-tile-sub-title>
              <v-list-tile-title class="eventSubTitle black--text">{{ event._source.eventLocationName }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text class="black--text">{{ event._source.eventPublishTime | moment('hh:mm a') }}</v-list-tile-action-text>
              <v-list-tile-action-text class="black--text">{{ event._source.eventPublishTime | moment('MMM D') }}</v-list-tile-action-text>
              <v-list-tile-action-text>
                <v-icon color="success" v-if="event.new">mdi-new-box</v-icon>
                <v-icon color="primary" class="infoIcons" v-if="attachments.length !== 0">mdi-paperclip</v-icon>
                <v-icon color="primary" v-if="event._source.eventScope === 'Local'">mdi-alpha-l-box</v-icon>
                <v-icon color="primary" v-if="event._source.eventScope === 'National'">mdi-alpha-n-box</v-icon>
                <v-icon color="primary" v-if="event._source.eventScope === 'Global'">mdi-alpha-g-box</v-icon>
              </v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
        </div>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EventList',
  props: {
    event: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    }
  },
  computed: {
    ...mapGetters({
      selected: 'selected',
      isLoading: 'isLoading'
    }),
    attachments() {
      return this.event._source.attachments.filter(a => {
        if (a.hasOwnProperty('deleted') && a.deleted) {
          return;
        } else {
          return ['photo', 'video'].includes(a.type);
        }
      });
    },
    variant() {
      switch (this.event._source.eventImportance) {
        case 'Warning':
          return 'warning';
        case 'Critical':
          return 'danger';
      }
      return 'secondary';
    },
    tabClasses() {
      return {
        cardInformation: this.variant === 'secondary',
        cardWarning: this.variant === 'warning',
        cardCritical: this.variant === 'danger'
      };
    }
  },
  methods: {
    onClick(index) {
      this.$emit('eventClickedOne');
      this.$store.dispatch('select', index);
      this.$ga.event('send', {
        eventCategory: 'Events',
        eventAction: `Event ${this.event._id} clicked`
      });
    }
  }
};
</script>

<style scoped>
.eventImportance {
  font-size: 0.9rem;
}
.cardInformation {
  border: solid #a0a0a0;
  border-width: 0 0 0 0.6rem;
}
.cardWarning {
  border: solid #ffa94b;
  border-width: 0 0 0 0.6rem;
}
.cardCritical {
  border: solid #ea4335;
  border-width: 0 0 0 0.6rem;
}
.eventTitle {
  font-size: 1.1rem;
  color: #085280 !important;
}
.newPill {
  background: red;
  color: white;
}
.eventSubTitle {
  font-size: 0.9rem;
}
.infoIcons {
  font-size: 0.5rem;
}
.active {
  background-color: #ecfffe !important;
}
</style>
